<script>
import { mapGetters } from 'vuex';
import Badge from '../Badge';

export default {
  name: 'XmlChannelStatusCardHeader',
  components: {
    Badge,
  },
  props: {
    xmlChannel: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      badges: 'xmlChannelStatus/getBadges',
    }),
  },
};
</script>

<template>
  <div>
    <v-card-title class="py-2">
      <v-layout justify-between align-center>
        <v-flex grow pa-0>
          <div>
            {{ xmlChannel.webservice }}
            <template v-if="xmlChannel.subChannelId">
              <span class="px-1">-</span>
              <span>{{ xmlChannel.subChannelName }}</span>
            </template>
          </div>
          <div class="caption">{{ xmlChannel.system }}</div>
        </v-flex>
        <v-flex shrink pa-0>
          <slot name="tooltip"></slot>
          <badge v-if="xmlChannel.latestJob" :badge="badges[xmlChannel.latestJob.status]"/>
          <badge v-else :badge="badges['NO_CONTENT']"/>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-divider class="mt-1 mx-2"/>
  </div>
</template>

<style lang="scss" scoped>
.title-status {
  width: 72px;
}
</style>



// WEBPACK FOOTER //
// src/components/xmlChannelStatus/XmlChannelStatusCardHeader.vue